import {toNumericTreeNodeId} from 'src/app/tree-browser/treeBrowserUtils';

export const documentTreeRootId = 'all';

/** Tree node id for a document/folder id; the root id for missing, zero or invalid ids. */
export const toDocumentTreeNodeId = (
  nodeId?: string | number | null
): string => toNumericTreeNodeId(nodeId, documentTreeRootId);

export const toDocumentListFilter = (nodeId?: string): {nodeId?: number} => {
  if (!nodeId || nodeId === documentTreeRootId || nodeId === '0') return {};

  const parsedNodeId = Number(nodeId);
  return Number.isSafeInteger(parsedNodeId) && parsedNodeId > 0
    ? {nodeId: parsedNodeId}
    : {};
};
